<template>
	<div class="omapi-monsterleads__filters">
		<div class="omapi-monsterleads__filters-campaign">
			<h2
				class="omapi-monsterleads__filters-campaign-label"
				@click.prevent="toggleSelect"
			>
				{{ campaignName }}
			</h2>
			<div class="omapi-monsterleads__filters-campaign-select-wrap">
				<span
					class="omapi-monsterleads__filters-campaign-label-arrow"
					@click.prevent="toggleSelect"
				/>

				<core-form-fancy-select-input
					name="campaigns"
					v-model="campaign"
					:options="campaignFilterOptions"
					class="omapi-input omapi-monsterleads__filters-campaign-select"
					:class="{ hidden: !viewSelect }"
					:close-on-select="false"
					searchPlaceholder="Type to search for Campaigns"
					@close="viewSelect = false"
					@select="viewSelect = false"
					ref="select"
				/>
			</div>
		</div>
		<div class="omapi-monsterleads__filters-right">
			<common-date-select
				class="omapi-monsterleads__filters-date"
				:minDate="minDate"
				:filter="dateRange.filter"
				:includeAllTime="true"
				:width="158"
				@quickSelect="updateFilter"
				@dateSelection="fetchLeadsFromDateRange"
			/>
			<select class="omapi-input__select omapi-monsterleads__filters-tag" v-model="tag">
				<option
					v-for="opt in tagFilterOptions"
					:key="opt.value"
					:value="opt.value"
				>{{ opt.name }}</option>
			</select>
		</div>
	</div>
</template>

<script>
import get from 'lodash/get'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('monsterleads')

export default {
	data () {
		return {
			viewSelect : false,
			minDate    : new Date(2019, 0), // Monster Leads didn't exist before this!
		}
	},
	mounted () {
		this.updateCampaignFilter(this.$get('$route.params.campaignId', this.campaignFilter))
		this.updateTagFilter(this.$get('$route.params.tagId', this.tagFilter))
	},
	watch : {
		viewSelect (view) {
			if (view) {
				const $el = this.$get('$refs.select.$refs.multiselect.$el')
				if ($el) {
					// Auto-open the select dropdown.
					this.$nextTick(() => $el.focus())
				}
			}
		},
	},
	computed : {
		...mapGetters([
			'campaignFilterOptions',
			'campaignFilter',
			'dateRange',
			'selectedCampaign',
			'tagFilterOptions',
			'tagFilter',
		]),
		campaign : {
			get () {
				return this.$get('selectedCampaign', {})
			},
			set (selected) {
				this.goToPage({ campaign: get(selected, 'value', selected), page: 1 })
			},
		},
		tag : {
			get () {
				return this.tagFilter
			},
			set (selected) {
				this.goToPage({ tag: selected, page: 1 })
			},
		},
		campaignName () {
			return this.$get('campaign.name', 'All Campaign Contacts')
		},
	},
	methods : {
		...mapActions([ 'goToPage', 'updateCampaignFilter', 'updateTagFilter', 'fetchLeadsFromDateRange' ]),
		toggleSelect () {
			this.viewSelect = !this.viewSelect
		},
		updateFilter (filter) {
			if ('custom' === filter) {
				// Only update filter, fetch comes after date-selection.
				return this.$store.commit('monsterleads/updateDateRange', {
					...this.dateRange,
					filter,
				})
			}

			this.fetchLeadsFromDateRange({
				filter,
				start : '',
				end   : '',
			})
		},
	},
}
</script>

<style lang="scss">
.omapi-screen .omapi-monsterleads__filters {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 10px;
	&-campaign {
		position: relative;

		&-label {
			display: inline-block;
			position: relative;
			min-width: 164px;
			font-weight: bold;
			font-size: 16px;
			line-height: 140%;
			cursor: pointer;
			margin: 0;

			&-arrow {
				display: inline-block;
				position: relative;
				// top: 2px;
				// left: 5px;
				z-index: 99;
				// top: 0;

				&:before {
					content: url('./../../../assets/images/icons/expand-more.svg');
					// top: 3px;
					border: none;
					display: block;
					transform: rotate(180deg);
				}

			}
		}

		&-select {
			&-wrap {
				display: inline-block;
				cursor: pointer;
				position: relative;
				top: 2px;
				left: 10px;
			}

			position: absolute;
			top: 12px;
			left: -169px;
			width: 338px;

			box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
			.multiselect__content-wrapper {
				box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
			}

			.multiselect__tags {
				position: relative;
				z-index: 99999;

				&:after {
					right: 11px !important;
				}
			}

			&:before, &:after {
				content: '';
				background: #fff;
				position: absolute;
				left: 50%;
				display: block;
				transform: rotate(45deg);
			}

			&:before {
				height: 6px;
				width: 6px;
				top: -4px;
				margin-left: 1px;
				border: 2px solid #C9D0D6;
			}

			&:after {
				height: 8px;
				width: 8px;
				top: -3px;
				margin-left: 2px;
				z-index: 55;
			}
		}
	}

	&-right {
		display: flex;
		align-items: center;
		.omapi-monsterleads__filters-tag {
			margin-left: 10px;
			height: 31px;
			line-height: 1.2em;
			width: 160px;
		}
	}

	&-date .omapi-dropdown__select {
		width: 160px;
	}
}
</style>
